import { Box, Grid, Tooltip, Typography } from '@mui/material';
import GoogleMap from '../../../../../common/components/maps/googlemap/GoogleMap';
import { useAppSelector } from '../../../../../app/redux/hooks';
import { capitalizeFirstLetter } from '../../../../../utils/commonFunctions';
import { useForm } from 'react-hook-form';
import GoogleCircle from '../../../../../common/components/maps/googlecircle/GoogleCircle';
import GoogleMarkers from '../../../../../common/components/maps/googlemarkers/GoogleMarkers';
import GooglePolygon from '../../../../../common/components/maps/googlepolygon/GooglePolygon';
import CustomTextField from '../../../../../common/components/customized/customtextfield/CustomTextField';
import { getGeofenceMappingAction } from '../../../redux/reducer/yaantracSlices/geofenceSlice';
import { Icon } from '@iconify/react';
import './GeofenceMapping.scss';
import CustomDeletePopup from '../../../../../common/components/customdelete/CustomDeletePopup';
import constants from '../../../../../utils/constants';
import CustomActivatePopup from '../../../../../common/components/customactive/CustomActivatePopup';
import GoogleDrawingManager from '../../../../../common/components/maps/googledrawingManager/GoogleDrawingManager';
import GeofenceCard from './GeofenceCard';
import LoginRedirect from '../../../../../common/components/loginredirect/LoginRedirect';
import { addIcon, menuIcon, useGeofenceStates } from '../hooks/geofenceCommonStates';
import { usePagination } from '../../../../../common/hooks/usePagination';
import GeofenceSkeleton from './GeofenceSkeleton';
import GeofenceSummary from './GeofenceSummary';
import { useGeoenceSearch } from '../hooks/geofenceSearch';
import { useGeofenceDispatch } from '../hooks/geofenceFormSubmission';
import AddGeofence from './AddGeofence';
import {
  useGeofenceDeactivate,
  useGeofenceDelete,
  useGeofenceUpdate
} from '../hooks/geofenceCardActions';
import { useGeofenceMenu } from '../hooks/geofenceCardMenu';
import { useGeofenceGooglemap } from '../hooks/geofenceGooglemap';
import { useGeofenceCardView, useGeofenceSummary } from '../hooks/geofenceCardView';
import { useGeofenceAssign } from '../hooks/geofenceAssignVehicle';
import { usegetGeofences } from '../hooks/getGeofences';

const GeofenceMapping = () => {
  const { data, isLoading, type } = useAppSelector(state => state?.geofences);
  const {
    data: geofencemapping,
    isLoading: geofenceLoading,
    count
  } = useAppSelector(state => state?.geofencemapping);
  const { fences } = useAppSelector(state => state.circle);
  const mapData = useAppSelector((state: any) => state.mapVehiclestatus);
  const { setValue, control, resetField, clearErrors } = useForm();

  const {
    row,
    setRow,
    setFilteredRow,
    filteredRow,
    isOpen,
    setIsOpen,
    setCardData,
    cardData,
    isCircular,
    setIsCircular,
    expanded,
    setExpanded,
    dispatch,
    createAbort,
    setCardOpen,
    cardOpen
  } = useGeofenceStates();

  const { pageNo, pageSize, handlePagination, setPageNo, setPageSize } = usePagination({
    pageno: 1,
    pagesize: 5,
    url: getGeofenceMappingAction,
    payloads: { geoZoneId: cardData?.geoZoneId }
  });

  const { handleSearchFilter, searchValue } = useGeoenceSearch({ data, setRow, row });
  const { getGeofences } = usegetGeofences({ data });

  useGeofenceDispatch({
    data,
    isOpen,
    dispatch,
    createAbort,
    cardOpen,
    setRow,
    getGeofences
  });
  const { isDelete, setIsDelete, handleDelete, deleteClose, handleGeofenceDelete } =
    useGeofenceDelete({
      setFilteredRow,
      dispatch,
      filteredRow,
      createAbort,
      setCardOpen,
      resetField
    });

  const { handleDeactivate, handleDeactivateGeofence, setIsActivate, isActivate } =
    useGeofenceDeactivate({
      setFilteredRow,
      dispatch,
      filteredRow,
      createAbort,
      resetField,
      setCardOpen
    });

  const { handleOpenSlide, handlesilder, handleAddGeofence } = useGeofenceMenu({
    setIsOpen,
    setFilteredRow,
    setCardOpen,
    setIsCircular,
    dispatch,
    setRow,
    data
  });

  const { onAssign } = useGeofenceAssign({
    dispatch,
    setIsCircular,
    setFilteredRow,
    setCardOpen,
    setIsOpen,
    cardData
  });

  const {
    viewEye,
    setViewEye,
    handleViewEye,
    geofenceMappingList,
    handleExpandClick,
    closeCardIcon,
    handleViewVehicle
  } = useGeofenceSummary({
    cardData,
    geofencemapping,
    setExpanded,
    expanded,
    setCardOpen,
    setRow,
    dispatch
  });

  const {
    handleLockIcon,
    toggleLock,
    setToggleLock,
    setMapClick,
    setAddress,
    address,
    mapClick,
    handleMapClick
  } = useGeofenceGooglemap({
    fences,
    dispatch,
    setValue,
    clearErrors,
    filteredRow
  });

  const { onView } = useGeofenceCardView({
    setCardOpen,
    dispatch,
    setPageNo,
    setPageSize,
    pageNo,
    pageSize,
    setIsCircular,
    setCardData,
    createAbort,
    mapData,
    setExpanded,
    setRow
  });

  const { onUpdate, isUpdate, setIsUpdate } = useGeofenceUpdate({
    dispatch,
    setIsCircular,
    data,
    setFilteredRow,
    setRow,
    setIsOpen,
    setCardOpen
  });
  return (
    <>
      <Grid container className='geofence-mapping'>
        {isOpen === '' && (
          <Grid item lg={3.1} md={4} sm={4} xs={8}>
            <Box className='search-header'>
              <Typography className='title-header'>
                {menuIcon && (
                  <Icon
                    icon={menuIcon?.icon}
                    width={menuIcon?.width}
                    height={menuIcon?.height}
                    color={menuIcon?.color}
                    onClick={handlesilder}
                  />
                )}
                {constants.GeofenceDetails}
              </Typography>
              <Tooltip title='Add' placement='right-start'>
                <>
                  {addIcon && (
                    <Icon
                      icon={addIcon?.icon}
                      width={addIcon?.width}
                      height={addIcon?.height}
                      onClick={handleAddGeofence}
                      className='add-icon'
                    />
                  )}
                </>
              </Tooltip>
            </Box>
            <Box className='geofence-searchcard'>
              <CustomTextField
                id='searchFilter'
                control={control}
                value={searchValue}
                name='searchFilter'
                placeholder='Search geofence'
                onChangeCallback={(e: any) => {
                  handleSearchFilter(e);
                }}
              />
            </Box>

            {isLoading ? (
              <GeofenceSkeleton isLoading={isLoading} />
            ) : (
              <Box className='geofence-card'>
                {row && row?.length > 0 ? (
                  row?.map((value: any, index: number) => (
                    <GeofenceCard
                      key={index}
                      geofenceName={capitalizeFirstLetter(value?.geofenceName)}
                      location={value?.location}
                      radius={value?.radius}
                      geoType={value?.geoType}
                      vehicleNumber={value?.vehicleNumber}
                      isActive={value?.isActive}
                      activeColor={value?.activeColor}
                      onView={() => onView(value)}
                      handleDeactivate={() => handleDeactivate(value)}
                      filteredRow={filteredRow}
                      onUpdate={() => onUpdate(value)}
                      onAssign={() => onAssign(value)}
                      handleDelete={() => handleDelete(value)}
                    />
                  ))
                ) : (
                  <Typography className='geofence-nodata'>
                    <Box>
                      <Icon className='nodata-icon' icon='wpf:geofence' />
                    </Box>
                    {constants.NoDataFound}
                  </Typography>
                )}
              </Box>
            )}
          </Grid>
        )}
        {isDelete && (
          <CustomDeletePopup
            open={isDelete}
            setOpen={setIsDelete}
            handleDelete={handleGeofenceDelete}
            handleClose={deleteClose}
            message={`${constants.DeleteCustomer} geofence?`}
            isLoading={type === 'delete-geofence' && isLoading}
          />
        )}

        {isActivate && (
          <CustomActivatePopup
            filteredRow={filteredRow}
            open={isActivate}
            setOpen={setIsActivate}
            handleDeactivate={handleDeactivateGeofence}
            isLoading={type === 'active-geofence' && isLoading}
          />
        )}

        <Grid
          className={`geofence-mapping-box ${isOpen === 'slider' ? 'full-slide' : ''}`}
          item
          lg={isOpen !== 'slider' && cardOpen ? 8.9 : isOpen === 'slider' ? 12 : 8.9}
          md={cardOpen ? 8 : 8}
          sm={cardOpen ? 8 : 8}
          xs={4}
        >
          <GoogleMap
            toggleLock={!toggleLock}
            isGeofence={true}
            handleMapClick={(value: any) => {
              if (
                isOpen === 'Add Geofence' ||
                (isOpen === 'Update Geofence' && mapClick === 'circular')
              ) {
                handleMapClick(value);
              }
            }}
            maplegend={false}
          >
            {(isOpen === 'Add Geofence' || isOpen === 'Update Geofence') &&
            !isCircular ? (
              <Box className='map-lock'>
                <Icon
                  icon={toggleLock ? 'mdi:lock-off' : 'material-symbols:lock-open'}
                  className='map-lock-icon'
                  onClick={handleLockIcon}
                />
              </Box>
            ) : (
              ''
            )}
            {isOpen === 'slider' && (
              <Box className='geofence-slider'>
                <Icon
                  className='geofence-slider-icon'
                  icon='iconamoon:menu-burger-horizontal-bold'
                  onClick={handleOpenSlide}
                />
              </Box>
            )}
            {<GoogleCircle />}
            <GoogleMarkers />
            <GooglePolygon />
            <GoogleDrawingManager updateID={filteredRow?.geoZoneId} />
            {cardOpen && (
              <GeofenceSummary
                handleExpandClick={handleExpandClick}
                expanded={expanded}
                closeCardIcon={closeCardIcon}
                cardData={cardData}
                handleViewEye={handleViewEye}
                geofenceLoading={geofenceLoading}
                geofenceMappingList={geofenceMappingList}
                pageNo={pageNo}
                pageSize={pageSize}
                handleViewVehicle={handleViewVehicle}
                count={count}
                handlePagination={handlePagination}
                viewEye={viewEye}
                setViewEye={setViewEye}
              />
            )}
          </GoogleMap>
        </Grid>
        {isOpen && (
          <Grid item lg={3} md={3} sm={3}>
            <AddGeofence
              setIsOpen={setIsOpen}
              isCircular={isCircular}
              setIsCircular={setIsCircular}
              isUpdate={isUpdate}
              setToggleLock={setToggleLock}
              setIsUpdate={setIsUpdate}
              isOpen={isOpen}
              filteredRow={filteredRow}
              setAddress={setAddress}
              setMapClick={setMapClick}
              address={address}
              setFilteredRow={setFilteredRow}
              setSearchValue={setValue}
            />
          </Grid>
        )}
      </Grid>
      <LoginRedirect />
    </>
  );
};

export default GeofenceMapping;
